import { NavigationData } from "@lib/base/components/navigation/sidebar/sidebar.component.types";

export const ADMIN_NAVIGATION: NavigationData = {
    settings: {
        prefix: "administration",
    },
    routes: [
        {
            key: "Dashboard",
            route: "dashboard",
            icon: "dashboard",
        },
        {
            key: "routing.administration.infrastructure._title",
            icon: "graph_4",
            children: [
                {
                    key: "routing.administration.infrastructure.gateways._title",
                    route: "infrastructure/stations",
                    icon: "router",
                    permissions: ["Station"],
                },
                {
                    key: "routing.administration.infrastructure.ble-tags._title",
                    route: "infrastructure/ble-tags",
                    icon: "bluetooth_searching",
                    permissions: ["TagShelfLabelZKong"],
                },
            ],
        },
        {
            key: "routing.administration.security._title",
            icon: "security",
            children: [
                {
                    key: "routing.administration.security.users._title",
                    route: "security/users",
                    icon: "supervisor_account",
                    permissions: ["User"],
                },
            ],
        },
    ],
};
